export var loadCertificates = function(params) {
  var p = params || {};
  var queryParams = {};

  if (p.filter_by) queryParams.filter_by = p.filter_by;
  if (p.from) queryParams.from = p.from;
  if (p.to) queryParams.to = p.to;

  var requestConfig = {
    method: "GET",
    url: "/certificates",
    showLoading: p.showLoading !== undefined ? p.showLoading : true,
  };

  if (Object.keys(queryParams).length > 0) {
    requestConfig.params = queryParams;
  }

  return {
    type: "LOAD_CERTIFICATES",
    payload: {
      request: requestConfig,
    },
  };
};

export var renewCertificate = function(id) {
  return {
    type: 'RENEW_CERTIFICATE',
    payload: {
      request: {
        method: 'post',
        url: '/certificates/' + id + '/renew',
      }
    }
  };
};

export var loadCertificateHistory = function(id) {
  return {
    type: 'LOAD_CERTIFICATE_HISTORY',
    payload: {
      request: {
        method: 'get',
        url: '/certificates/' + id + '/history',
        showLoading: false,
      }
    }
  };
};
